module.exports = __webpack_public_path__ + "assets/daoru.e16bfbdb71d9655abdc7c15c95b8e01f.png";